export class Ajax {
    constructor(type, url, data, onsuccess, onerror) {
        if (type.toLowerCase() === 'get') {
            return this.GET(NOJESRESOR_API_URL + url, onsuccess, onerror);
        }

        if (type.toLowerCase() === 'post') {
            return this.POST(
                NOJESRESOR_API_URL + url,
                data,
                onsuccess,
                onerror,
            );
        }

        if (type.toLowerCase() === 'post_wordpress') {
            return this.POST_WORDPRESS(url, data, onsuccess, onerror);
        }
    }

    /**
     *
     * GET
     */
    POST(url, data) {
        const request = new Request(url, {
            method: 'POST',
            headers: new Headers({
                'Content-type': 'application/json',
            }),
            body: data != null ? JSON.stringify(data) : null,
        });

        return fetch(request)
            .then(function(response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    var error = new Error(response.statusText);
                    error.response = response;
                    throw error;
                }
            })
            .then(function(response) {
                return response.json();
            })
            .then((result) => {
                return result;
            });
    }

    POST_WORDPRESS(url, data) {
        const request = new Request(url, {
            method: 'POST',
            headers: {
                'HTTP_X_WP_NONCE': data.security,
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(data),
            credentials: 'include',
        });

        return fetch(request)
            .then(function(response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    const error = new Error(response.statusText);
                    error.response = response;
                    throw error;
                }
            })
            .then(function(response) {
                return response.json();
            })
            .then((result) => {
                return result;
            });
    }

    /**
     *
     * GET
     */
    GET(url) {
        const request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-type': 'application/x-www-form-urlencoded',
            }),
        });

        return fetch(request)
            .then(function(response) {
                if (response.status >= 200 && response.status < 300) {
                    return response;
                } else {
                    const error = new Error(response.statusText);
                    error.response = response;
                    throw error;
                }
            })
            .then(function(response) {
                return response.json();
            })
            .then((result) => {
                return result;
            })
            .catch((response) => {
                throw response;
            });
    }
}
